// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__m6-KX","footertoolbar":"footer_footertoolbar__LTiF5","footerbutton":"footer_footerbutton__IPMLj","footeritem":"footer_footeritem__V0OGp"};